import { allPagePermissionTagStrings } from './admin-panel/permissions';

// Below are the standard tags that can be assigned to a user and/or a user group.
export const permissionTags = {
  user_manager: {},
  admin: {},
  'admin-panel': {},
  screener: {},
  reviewer: {},
  support: {},
  'internal audit': {},
} as const;

export type PermissionTag = keyof typeof permissionTags;

export const restrictionTags = {
  'no-tabs': {},
  'no-notes': {},
  'no-comms': {},
  'no-history': {},
  'no-internal audit': {},
  'no-meetings': {},
  'no-fraud': {},
  'read-only': {},
} as const;

export type RestrictionTag = keyof typeof restrictionTags;

// Derived from the centralized structures in permissions.ts.
// Adding a page to ADMIN_PANEL_PAGES automatically makes it a valid PagePermissionTag.
export const pagePermissionTags: Record<string, {}> = Object.fromEntries(
  allPagePermissionTagStrings.map(tag => [tag, {}])
);

export type PagePermissionTag = string & keyof typeof pagePermissionTags;

export const isPagePermissionTag = (tag: string): tag is PagePermissionTag => {
  return tag in pagePermissionTags;
}

export const standardTags = { ...permissionTags, ...restrictionTags, ...pagePermissionTags } as const;

export type StandardTag = keyof typeof standardTags;

export const isPermissionTag = (tag: string): tag is PermissionTag => {
  return tag in permissionTags;
}

export const isRestrictionTag = (tag: string): tag is RestrictionTag => {
  return tag in restrictionTags;
}
